// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2ZaCt","info":"Note_info__2mUi8","note":"Note_note__3B47C","actions":"Note_actions__1Pz4C"};